import { useState, useEffect, createContext, useContext } from "react";
import { useArrangement } from "./ArrangementProvider";
import { useAuth } from "./AuthProvider";
import environment from "../env";

const NavContext = createContext();
export const useNav = () => useContext(NavContext);

const NavProvider = ({ children }) => {
  const { accessToken } = useAuth();
  const { hasArrangement } = useArrangement();

  const [hideHeaderNavBars, setHideHeaderNavBars] = useState(false);
  const [navigation, setNavigation] = useState([]);
  const [showFooter, setShowFooter] = useState(false);
  const [showCallMeIcon, setShowCallMeIcon] = useState(true);
  const [hideSignOut, setHideSignOut] = useState(false);

  const apiUrl = environment.CUSTOMER_PORTAL_API;

  // Shared headers for API calls (same pattern as LiveLoansProvider)
  const defaultOptions = {
    headers: {
      "x-api-key": environment.CUSTOMER_PORTAL_API_KEY,
      "Authorization": `Bearer ${accessToken}`,
      "organisation": environment.CLIENT_NAME,
      "Content-Type": "application/json",
    },
  };

  // Combine nav effects into one
  useEffect(() => {
    const navItems = [
      {
        name: "My Financial Statement",
        id: "nav-sfs",
        href: "/sfs",
        current: false,
        hide: hideHeaderNavBars,
      },
      {
        name: "Transactions",
        id: "transaction-history",
        href: "/transaction-history",
        current: false,
        hide: hideHeaderNavBars,
      },
      {
        name: "Manage Saved Cards",
        id: "manage-cards",
        href: "/manage-cards",
        current: false,
        hide: hideHeaderNavBars,
      },
    ];
    setNavigation(navItems);
  }, [hideHeaderNavBars, hasArrangement]);

  /**
   * Post analytics to backend (same style as LiveLoansProvider)
   */
  async function postAnalytics(payload) {
    if (!accessToken) {
      console.warn("Skipping analytics post: no access token.");
      return null;
    }

    let analyticsResponse = null;

    const requestOptions = {
      ...defaultOptions,
      method: "POST",
      body: JSON.stringify(payload),
    };

    console.info("post analytics request:", { url: `${apiUrl}/analytics`, requestOptions });

    try {
      await fetch(`${apiUrl}/analytics`, requestOptions)
        .then((res) => res.json())
        .then((data) => {
          console.log("post analytics response:", data);
          analyticsResponse = data;
        });
    } catch (error) {
      console.error(`Error posting analytics: ${error}`);
      return null;
    }

    return analyticsResponse;
  }

  const contextValue = {
    navigation,
    settings: [{ name: "Sign out", id: "logout", href: "#" }],
    showFooter,
    setShowFooter,
    hideHeaderNavBars,
    setHideHeaderNavBars,
    postAnalytics,
    showCallMeIcon,
    setShowCallMeIcon,
    setHideSignOut,
    hideSignOut,
  };

  return (
    <NavContext.Provider value={contextValue}>{children}</NavContext.Provider>
  );
};

export default NavProvider;
